import { noop } from '../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { ServiceFittingStation } from './rows/service_fitting_station';
import { ShippingPrice } from './rows/shipping_price';
import { TotalPrice } from './rows/total_price';
import { AddServiceFittingStation } from './rows/add_service_fitting_station';
import { ServiceFittingStationNotAvailable } from './rows/service_fitting_station_not_available';
import { Product } from './rows/product';
import { GoToCheckout } from './rows/go_to_checkout';
import { OptionSeparator } from './rows/option_separator';
import { Table } from './structure/table';
import { calculateSetPrice } from '../../helper/calculate_set_price';
import { getQuantityOfProducts } from '../../../_modules/product/get_quantity_of_products';
import { featureFlags } from '../../../_constants/feature_flags';
import { AllItems } from './rows/all_items';
import { Discount } from './rows/discount';
import Translation from '../translation/translation';

export const Cart = (props) => {
  const { products } = props;
  const hasWheelAlignment = props.wheelAlignmentQuantity > 0;

  if (!products.length) {
    return null;
  }

  const rows = [
    products.length === 1 && getProductRow(props),

    products.length > 1 && getProductsRow(props, props.allItemsPrice),

    props.hasFitting && getFittingStationRow(props),

    props.shippingPrice !== -1 && getShippingRow(props),

    getDiscountRow(props),

    getTotalPriceRow(props),

    // shouldDisplayMatesRates(products)
    //     && getTotalPriceMatesRatesRow(props),

    !!props.fittingStationAllowed && props.fittingNotAvailable && getFittingNotAvailableRow(props),

    !!props.fittingStationAllowed && !props.fittingNotAvailable && !props.hasFitting && getAddFittingServiceRow(props),

    // !!props.fittingStationAllowed && !props.fittingNotAvailable && !props.hasFitting && <OptionSeparator key="AboveGoToCheckoutSeparator" />,

    getGoToCheckoutRow(props),
  ];

  const [firstProduct] = products;
  return [
    <Table rows={rows} key="Sidebar" hasFitting={props.hasFitting} />,
  ];
};

const getProductRow = ({ products, currencyIsoCode, onMatesRatesLearnMoreClick, isMpsProduct, cartProducts, shipments }) => {
  const [product] = products;
  if (!isMpsProduct && cartProducts !== 'undefined' && cartProducts.length === 1) {
    isMpsProduct = cartProducts[0].hasOwnProperty('productStock') ? cartProducts[0].productStock.isMpsProduct : false;
  }

  return (
    <Product
      type={product.type}
      brand={product.brand}
      name={product.model}
      description={product.size}
      buy4pay3={product.buy4pay3 === 1}
      cashback100={product.cashback100}
      quantity={parseInt((product.qty || 1), 10)}
      pricePerItem={product.price}
      setPrice={calculateSetPrice(product.qty, product.price, {
        buy4pay3: product.buy4pay3 === 1,
        cashback100: product.cashback100,
      })}
      currencyIsoCode={currencyIsoCode}
      onMatesRatesLearnMoreClick={onMatesRatesLearnMoreClick}
      key={product.brand + product.model}
      isMpsProduct={isMpsProduct}
      clearance={product.clearance}
      isFittingAvailable={product.isFittingAvailable}
      lightContentAvailable={product.lightContentAvailable}
      productId={product.id}
      shipments={shipments}
      productUrl={product.url}
    />
  );
};

const getProductsRow = (props, allItemsPrice) => (
  <AllItems
    products={props.products}
    currencyIsoCode={props.currencyIsoCode}
    showDetails={false}
    allItemsPrice={allItemsPrice}
    onMatesRatesLearnMoreClick={props.onMatesRatesLearnMoreClick}
    onShowProductDetailsClick={props.onShowProductDetailsClick}
    shouldDisplayMatesRates={shouldDisplayMatesRates(props.products)}
    cartProducts={props.cartProducts}
    shipments={props.shipments}
    key="Products"
  />
);

const getFittingStationRow = (props) => {
  const fsTotalPrice = props.fittingPrice + props.wheelAlignmentPrice + props.calloutFeePrice;

  return (
    <ServiceFittingStation
      fsTotalPrice={fsTotalPrice}
      quantity={getQuantityOfProducts(props.products)}
      hasFitting={props.hasFitting}
      hasWheelAlignment={props.hasWheelAlignment}
      fittingPrice={props.fittingPrice}
      isMobileFitter={props.isMobileFitter}
      calloutFeePrice={props.calloutFeePrice}
      fittingStationStreet={props.fittingStationStreet}
      fittingStationSuburb={props.fittingStationSuburb}
      sidebarPostcode={props.sidebarPostcode}
      wheelAlignmentQuantity={props.wheelAlignmentQuantity}
      wheelAlignmentPrice={props.wheelAlignmentPrice}
      onMoreInfoWheelAlignmentClick={props.onMoreInfoWheelAlignmentClick}
      onChangeStationClick={props.onChangeStationClick}
      onRemoveStationClick={props.onRemoveStationClick}
      onShowFsDetailsClick={props.onShowFsDetailsClick}
      fsDetailsVisible={props.fsDetailsVisible}
      currencyIsoCode={props.currencyIsoCode}
      loading={props.loading}
      isMpsProduct={props.isMpsProduct}
      key="ServiceFittingStation"
    />
  );
};

export const getShippingRow = (props) => (
  <ShippingPrice
    hasAccessories={props.hasAccessories}
    hasWheels={props.hasWheels}
    hasTools={props.hasTools}
    shippingPrice={props.shippingPrice}
    shippingTime={props.shippingTime}
    isMobileFitter={props.isMobileFitter}
    sidebarPostcode={props.sidebarPostcode}
    currencyIsoCode={props.currencyIsoCode}
    loading={props.loading}
    allowChangeShipping={!props.hasFitting}
    onCalculateClick={props.onCalculate}
    onShowProductDetailsClick={props.onShowProductDetailsClick}
    fromCart={true}
    key="ShippingPrice"
  />
);

export const getDiscountRow = (props) => (
  <Discount
    discountInfo={props.discountInfo}
    currencyIsoCode={props.currencyIsoCode}
    loading={props.loading}
    onRemoveDiscountClick={props.onRemoveDiscountClick}
    allowDelete={true}
    key="Discount"
  />
);

const getGstInfo = [
  <div className="total-price__gst" key="sidebar-cart-gst">
    <Translation translationKey="include-gst" placeholder={{ TAX: TYROOLA.initialFluxStates.tax }} />
  </div>,
];
export const getTotalPriceRow = (props) => (
  <TotalPrice
    totalPrice={props.totalPrice}
    currencyIsoCode={props.currencyIsoCode}
    loading={props.loading}
    key="TotalPrice"
    labelExtraChildren={getGstInfo}
  />
);
// TODO: Temporary disabled matesrates
// export const getTotalPriceMatesRatesRow = props => (
//     <TotalPrice
//         totalPrice={props.totalPriceMatesRates}
//         currencyIsoCode={props.currencyIsoCode}
//         loading={props.loading}
//         currencySetupOverrides={{ decimalDigits: 2 }}
//         name="total-price total-price--mates-rates"
//         labelKey="pdp-sidebar-total-price-mates-rates"
//         key="TotalPriceMatesRates"
//         onLabelClick={props.onMatesRatesLearnMoreClick}
//     />
// );

const getFittingNotAvailableRow = (props) => (
  <ServiceFittingStationNotAvailable
    onLearnMoreClick={props.onFittingNotAvailableLearnMoreClick}
    key="ServiceFittingStationNotAvailable"
  />
);

const getAddFittingServiceRow = (props) => (
  <AddServiceFittingStation
    onLearnMoreClick={props.onAddFittingServiceLearnMoreClick}
    onAddServiceFittingStationClick={props.onAddServiceFittingStationClick}
    key="AddServiceFittingStation"
  />
);

const getGoToCheckoutRow = (props) => (
  <GoToCheckout
    fittingStationAllowed={false}
    hasFitting={false}
    hasBorder={false}
    baseUrl={props.baseUrl}
    key="GoToCheckout"
  />
);

function shouldDisplayMatesRates(products) {
  let totalBuy4Pay3 = 0;
  for (var i = 0; i < products.length; i++) {
    totalBuy4Pay3 = totalBuy4Pay3 + parseInt(products[i].buy4pay3);
  }

  return featureFlags.FEATURE_FRIEND_BUY && totalBuy4Pay3 <= 0;
}

Cart.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  allItemsPrice: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onChangeStationClick: PropTypes.func.isRequired,
  onRemoveStationClick: PropTypes.func.isRequired,
  fittingPrice: PropTypes.number.isRequired,
  calloutFeePrice: PropTypes.number.isRequired,
  wheelAlignmentQuantity: PropTypes.number.isRequired,
  wheelAlignmentPrice: PropTypes.number.isRequired,
  fittingNotAvailable: PropTypes.bool.isRequired,
  fittingStationAllowed: PropTypes.bool.isRequired,
  hasFitting: PropTypes.bool.isRequired,
  hasWheelAlignment: PropTypes.bool,
  hasShipping: PropTypes.bool.isRequired,
  hasAccessories: PropTypes.bool,
  hasWheels: PropTypes.bool,
  hasTools: PropTypes.bool,
  discountInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingPrice: PropTypes.number.isRequired,
  shippingTime: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  totalPriceMatesRates: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  isMobileFitter: PropTypes.bool.isRequired,
  baseUrl: PropTypes.string.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  onMoreInfoWheelAlignmentClick: PropTypes.func.isRequired,
  onAddServiceFittingStationClick: PropTypes.func.isRequired,
  onAddFittingServiceLearnMoreClick: PropTypes.func.isRequired,
  onFittingNotAvailableLearnMoreClick: PropTypes.func.isRequired,
  onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
  onCalculate: PropTypes.func.isRequired,
  onShowFsDetailsClick: PropTypes.func.isRequired,
  onShowProductDetailsClick: PropTypes.func.isRequired,
  fsDetailsVisible: PropTypes.bool.isRequired,
  onAddToCartClick: PropTypes.func,
  onRemoveDiscountClick: PropTypes.func,
  fittingStationId: PropTypes.string,
  fittingStationStreet: PropTypes.string,
  fittingStationSuburb: PropTypes.string,
  sidebarPostcode: PropTypes.string,
  isMpsProduct: PropTypes.bool,
  cartProducts: PropTypes.arrayOf(PropTypes.object),
};

Cart.defaultProps = {
  onAddToCartClick: noop,
  onRemoveDiscountClick: noop,
  fittingStationStreet: '',
  fittingStationSuburb: '',
  sidebarPostcode: '',
  isMpsProduct: false,
  cartProducts: [],
};
